import Container from "../components/Container";
import Image from "../components/Image";
import Text from "../components/Text";
import badGateway from "../assets/images/error_image.png";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";

const BadGatewayPage = () => {
    const navigate = useNavigate();

    return (
        <Container flexColumn fullWidth gap={3} className="mt-4 p-2 mb-8 sm:mb-0 align-items-center shadow-2 sm:min-h-0 min-h-screen" style={{ backgroundColor: "#FAFAFB", height: "calc(100vh - 150px)" }}>
            <Image src={badGateway} />

            <Text size="5xl" color="primary" fontWeight="medium">Erro</Text>

            <p className="text-center line-height-4">
                Ops! Parece que houve um problema ao tentar se conectar com o servidor.<br />
                Estamos trabalhando para resolver isso o mais rápido possível.<br />
                Por favor, tente novamente em alguns instantes.<br />
                Se o problema persistir, entre em contato com nosso suporte.
            </p>

            <Button onClick={() => navigate(-1)} className="bg-primary text-white shadow-2">
                Tentar novamente
            </Button>
        </Container>
    )
}

export default BadGatewayPage;